export default (sel, base = document) => base.querySelectorAll(sel);
